import { styled } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

const SECTION_HEIGHT = 400;

export const Section = styled.div`
  flex-shrink: 0;
  display: flex;
  background-color: #eff3f6;
  justify-content: center;
  align-items: center;
  position: relative;
  max-width: 100vw;
  overflow: hidden;
  gap: ${({ theme }) => theme.space[6]};
  flex-direction: column;

  ${({ theme }) => theme.mediaQueries.up({ breakpointAlias: 'sm2' })} {
    height: ${pxToRem(SECTION_HEIGHT)};
    flex-direction: row;
    background-color: #f4f7f8;
  }
`;

export const Inner = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  max-width: ${pxToRem(1280)};
  padding: 0 ${({ theme }) => theme.space[8]} ${({ theme }) => theme.space[8]};
  align-items: flex-end;
  justify-content: center;
  gap: ${({ theme }) => theme.space[8]};

  ${({ theme }) => theme.mediaQueries.up({ breakpointAlias: 'sm2' })} {
    align-items: center;
    justify-content: flex-start;
  }

  ${({ theme }) => theme.mediaQueries.up({ breakpointAlias: 'md' })} {
    padding: 0 ${pxToRem(90)} 0;
    gap: ${({ theme }) => theme.space[10]};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.space[5]};
  max-width: ${pxToRem(410)};

  ${({ theme }) => theme.mediaQueries.up({ breakpointAlias: 'sm2' })} {
    align-items: flex-start;
  }
`;

export const MobileImage = styled.img`
  width: 100%;

  ${({ theme }) => theme.mediaQueries.up({ breakpointAlias: 'sm2' })} {
    display: none;
  }
`;

export const DesktopImageContainer = styled.div`
  flex: 1;
  height: 100%;
  position: relative;
  display: none;

  ${({ theme }) => theme.mediaQueries.up({ breakpointAlias: 'sm2' })} {
    display: block;
  }
`;

export const DesktopImage = styled.img`
  position: absolute;
  left: 0;
  top: 0;
  width: max(100%, ${pxToRem(620)});

  animation: floatUpDown 30s linear infinite;

  @keyframes floatUpDown {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(calc(-100% + ${pxToRem(SECTION_HEIGHT)}));
    }
  }
`;
